import React from 'react';
import { FaClock, FaCamera, FaFolder } from 'react-icons/fa';
import { TimelineEvent, TimelineOther } from './TimelineComponents';

export function TimelineView({ timelineData, onPhotoClick }) {
  let photoIndex = 0;

  return (
    <div className="relative" data-testid="timeline-view">
      <div className="text-center mb-8">
        <div className="inline-flex items-center px-4 py-2 bg-blue-600 text-white rounded-full shadow-lg">
          <FaClock className="mr-2" />
          <span className="font-medium">Family Memories Timeline</span>
        </div>
      </div>
      
      {timelineData.events.map(event => {
        const startIdx = photoIndex;
        photoIndex += event.photos.length;
        return (
          <TimelineEvent key={event.id} event={event} photos={event.photos} onPhotoClick={onPhotoClick} startIndex={startIdx} />
        );
      })}
      
      {timelineData.albums.map(album => {
        const startIdx = photoIndex;
        photoIndex += album.photos.length;
        return (
          <TimelineOther key={album.id} title={album.name} icon={<FaFolder />} photos={album.photos} onPhotoClick={onPhotoClick} startIndex={startIdx} />
        );
      })}
      
      {timelineData.other.length > 0 && (
        <TimelineOther title="Other Memories" icon={<FaCamera />} photos={timelineData.other} onPhotoClick={onPhotoClick} startIndex={photoIndex} />
      )}
      
      <div className="relative pl-8">
        <div className="absolute left-0 top-0 w-4 h-4 -translate-x-1/2 rounded-full bg-gray-400 border-4 border-white shadow-md"></div>
        <div className="ml-4 text-gray-500 text-sm">Beginning of memories</div>
      </div>
    </div>
  );
}
